import { useStorage } from "@vueuse/core";
import { defineStore } from "pinia";
import { onMounted, type Ref, ref } from "vue";

/**
 * Use this store for small settings when it becomes more complex move it to separate store.
 */
export const useLanguageStore = defineStore("language-store", () => {
    const languages: Ref<string[]> = ref(["NL"]);
    const currencies: Ref<string[]> = ref(["EUR"]);
    const languageIndex: Ref<number> = useStorage("language-index", 0);
    const currencyIndex: Ref<number> = useStorage("currency-index", 0);
    const currentIso = (): string => languages.value[languageIndex.value];
    const currentCurrency = (): string => currencies.value[currencyIndex.value];
    const isValidIso = (lang: string): boolean =>
        languages.value.includes(lang);

    onMounted(() => {
        const metaLanguages: HTMLMetaElement | null = document.querySelector(
            `meta[name="languages"]`,
        );

        if (metaLanguages) {
            languages.value = metaLanguages.content.split(",");
        }

        const metaCurrencies: HTMLMetaElement | null = document.querySelector(
            `meta[name="currencies"]`,
        );

        if (metaCurrencies) {
            currencies.value = metaCurrencies.content.split(",");
        }
    });

    return {
        currencies,
        languages,
        languageIndex,
        currencyIndex,
        currentIso,
        currentCurrency,
        isValidIso,
    };
});
